import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Org-index-1992f2b8a31d9e33d-1'),
    routerUrl: '/Org',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Org')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Org-index-1992f2b8a31d9e33d-2'),
        routerUrl: '/OrgForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./OrgForm')),
      },
      //$MORE$
    ],
  },
];
